export default "__VITE_ASSET__be6e5708__"